import React from "react";
import { useStickyTableHeader } from "../../hooks/useStickyTableHeader";

const parseTableElement = (children) => {
  if (!React.isValidElement(children) || children.type !== "table") {
    return null;
  }

  const { className, children: tableChildren, ...tableProps } = children.props;
  const parts = React.Children.toArray(tableChildren);
  const thead = parts.find(
    (child) => React.isValidElement(child) && child.type === "thead"
  );
  const body = parts.filter(
    (child) => !(React.isValidElement(child) && child.type === "thead")
  );

  return { className, tableProps, thead, body };
};

const StickyTable = ({
  children,
  refreshDeps = [],
  scrollClassName = "text-nowrap",
  wrapClassName = "",
}) => {
  const parsedTable = parseTableElement(children);
  const {
    tableWrapRef,
    tableScrollRef,
    tableRef,
    theadRef,
    fixedHeaderTableRef,
    tableScrollLeft,
    showStickyActionShadow,
    isHeaderFixed,
    fixedHeaderMetrics,
    handleTableScroll,
  } = useStickyTableHeader(refreshDeps);

  const scrollClasses = [
    "table-responsive",
    "sticky-table-body-scroll",
    showStickyActionShadow ? "sticky-action-shadow" : "",
    scrollClassName,
  ]
    .filter(Boolean)
    .join(" ");
  const wrapClasses = [
    "sticky-table-wrap",
    showStickyActionShadow ? "sticky-action-shadow" : "",
    wrapClassName,
  ]
    .filter(Boolean)
    .join(" ");

  if (!parsedTable) {
    return children;
  }

  const { className, tableProps, thead, body } = parsedTable;
  const theadProps = thead?.props || {};

  return (
    <div ref={tableWrapRef} className={wrapClasses}>
      {isHeaderFixed && (
        <div
          className="sticky-table-fixed-header"
          style={{
            position: "fixed",
            top: fixedHeaderMetrics.top,
            left: fixedHeaderMetrics.left,
            width: fixedHeaderMetrics.width,
            zIndex: 100,
            overflow: "hidden",
          }}
        >
          <table
            ref={fixedHeaderTableRef}
            className={className}
            style={{
              marginLeft: -tableScrollLeft,
              width: fixedHeaderMetrics.tableWidth,
              minWidth: fixedHeaderMetrics.tableWidth,
            }}
            {...tableProps}
          >
            <thead {...theadProps}>{theadProps.children}</thead>
          </table>
        </div>
      )}
      <div
        ref={tableScrollRef}
        className={scrollClasses}
        onScroll={handleTableScroll}
      >
        <table ref={tableRef} className={className} {...tableProps}>
          <thead ref={theadRef} {...theadProps}>
            {theadProps.children}
          </thead>
          {body}
        </table>
      </div>
    </div>
  );
};

export default StickyTable;
